import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PayoutsFormComponent } from './payouts-form.component';
import { InputModule } from '../form-group/input';
import { ToggleModule } from '../form-group/toggle/toggle.module';
import { TextareaModule } from '@components/form-group/textarea/textarea.module';

@NgModule({
  declarations: [PayoutsFormComponent],
  imports: [
    CommonModule,
    InputModule,
    ToggleModule,
    TextareaModule
  ],
  exports: [
    PayoutsFormComponent
  ]
})
export class PayoutsFormModule { }
